import React from 'react';
import PropTypes from 'prop-types';
import CIcon from '@coreui/icons-react';
import { CFormFeedback, CFormLabel, CFormTextarea, CCol, CRow, CPopover } from '@coreui/react-pro';

import { Media } from '../Media';

const SimpleInputEmbedGroup = ({ id, label, isRequired, value, error, handleChange, disabled, rows, tooltip }) => {
     return (
          <div className="form-group">
               <CRow>
                    <CFormLabel htmlFor={id}>
                         {label && <span className="me-1">{label}</span>}
                         {tooltip && (
                              <CPopover content={tooltip} placement="top" trigger="hover">
                                   <CIcon icon="icon-info-cilcle" />
                              </CPopover>
                         )}
                         {isRequired && <span className="text-danger">*</span>}
                    </CFormLabel>
                    <CCol md={value ? 5 : 12}>
                         <CFormTextarea
                              id={id}
                              name={id}
                              invalid={isRequired && !!error}
                              value={value}
                              onChange={handleChange}
                              disabled={disabled}
                              rows={rows}
                         />
                         {isRequired && <CFormFeedback invalid>{error}</CFormFeedback>}
                    </CCol>
                    <CCol md={value ? 7 : 12} className="d-flex justify-content-center align-items-center">
                         <Media src={value} />
                    </CCol>
               </CRow>
          </div>
     );
};

SimpleInputEmbedGroup.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
     isRequired: PropTypes.bool,
     value: PropTypes.any,
     error: PropTypes.string,
     handleChange: PropTypes.func,
     disabled: PropTypes.bool,
     rows: PropTypes.string,
     tooltip: PropTypes.string,
};

SimpleInputEmbedGroup.defaultProps = {
     value: '',
     rows: '4',
};

export default SimpleInputEmbedGroup;
